export default function Section({
  slug,
  title,
  content,
  wrapperClass,
  template
}) {
  const sectionClasses = wrapperClass ? `wrapper ${wrapperClass}` : "wrapper";
  const pageTemplate = template ? template.replace(".php", "") : null;
  return (
    <section id={slug} className={pageTemplate}>
      <div className={sectionClasses}>
        <div className="content-wrapper">
          <hgroup>
            <h2>{title}</h2>
            <hr />
          </hgroup>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    </section>
  );
}
